module.exports = __webpack_public_path__ + "static/img/slide_2_fr.4cde48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_2_fr.png
// module id = qAmX
// module chunks = 0